import { useState } from 'react';
import { Meta, useLazyUserMetaQuery } from '../../../graphql/graphql';
import useMeta from '../../Meta/Hooks/useMeta';
import { useEffectAsync } from '../../../helpers';
import useLoading from '../../Base/Hooks/useLoading';

export default function useUserMeta({ userId }: { userId: string }) {
	const { isLoading, setIsLoading } = useLoading(true);
	const [meta, setMeta] = useState<Record<string, any>>({});
	const { getMetaAsObject } = useMeta();
	const [geUserMeta] = useLazyUserMetaQuery();

	const handleLoadMeta = async () => {
		const userMetaData = await geUserMeta({ id: userId });
		if (userMetaData?.data?.user?.meta) {
			const transformedMeta = getMetaAsObject(
				userMetaData?.data?.user?.meta as Meta[],
			);
			setMeta(transformedMeta);
		}
		setIsLoading(false);
	};

	useEffectAsync(async () => {
		await handleLoadMeta();
	}, []);

	return {
		userMeta: meta,
		reFetchUserMeta: handleLoadMeta,
		isLoadingUserMeta: isLoading,
	};
}
